import { JSX } from 'react'

import { IconProps } from '../../icon'

const AddUser: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M20.7224 24.5862C25.0209 24.5862 28.5155 21.0916 28.5155 16.7931C28.5155 12.4946 25.0209 9 20.7224 9C16.4238 9 12.9293 12.4946 12.9293 16.7931C12.9293 21.0916 16.4238 24.5862 20.7224 24.5862ZM20.7224 11.461C23.6591 11.461 26.0545 13.8563 26.0545 16.7931C26.0545 19.7299 23.6591 22.1252 20.7224 22.1252C17.7856 22.1252 15.3902 19.7299 15.3902 16.7931C15.3902 13.8563 17.7856 11.461 20.7224 11.461Z'
      fill='black'
    />
    <path
      d='M32.2069 23.7659C29.5819 23.7659 27.2521 25.0784 25.8412 27.08C25.7755 27.08 25.7099 27.0472 25.6443 27.0472H17.6051C13.1261 27.0472 9.23778 30.23 8.35183 34.627L8.0237 36.2348C7.89244 36.9075 8.31901 37.5473 8.99168 37.6786C9.07371 37.6786 9.15575 37.695 9.23778 37.695C9.81201 37.695 10.3206 37.2848 10.4355 36.7106L10.7636 35.1028C11.4198 31.8543 14.291 29.4917 17.6051 29.4917H24.7255C24.5451 30.148 24.4138 30.8207 24.4138 31.5425C24.4138 35.8411 27.9084 39.3356 32.2069 39.3356C36.5054 39.3356 40 35.8411 40 31.5425C40 27.244 36.5054 23.7495 32.2069 23.7495V23.7659ZM32.2069 36.8911C29.2701 36.8911 26.8748 34.4957 26.8748 31.559C26.8748 28.6222 29.2701 26.2268 32.2069 26.2268C35.1437 26.2268 37.539 28.6222 37.539 31.559C37.539 34.4957 35.1437 36.8911 32.2069 36.8911Z'
      fill='black'
    />
    <path
      d='M33.4374 30.3285V28.2777C33.4374 27.605 32.8796 27.0472 32.2069 27.0472C31.5343 27.0472 30.9764 27.605 30.9764 28.2777V30.3285H28.9256C28.253 30.3285 27.6951 30.8863 27.6951 31.559C27.6951 32.2316 28.253 32.7894 28.9256 32.7894H30.9764V34.8403C30.9764 35.5129 31.5343 36.0707 32.2069 36.0707C32.8796 36.0707 33.4374 35.5129 33.4374 34.8403V32.7894H35.4882C36.1609 32.7894 36.7187 32.2316 36.7187 31.559C36.7187 30.8863 36.1609 30.3285 35.4882 30.3285H33.4374Z'
      fill='black'
    />
  </svg>
)

export default AddUser
